/* ROUGE VIF — scripts légers (vanilla, chargé en defer) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) document.documentElement.classList.add('rv-anim');

  function fmt(n, dec) {
    return n.toLocaleString(document.documentElement.lang || 'fr-FR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }

  /* Compteur : défile de 0 à la valeur quand il entre à l'écran */
  function animateCount(el) {
    if (el.getAttribute('data-done')) return;
    el.setAttribute('data-done', '1');
    var target = parseFloat(el.getAttribute('data-rv-count')) || 0;
    var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    if (reduce) { el.textContent = fmt(target, dec); return; }
    var duree = 1400, t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / duree);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * e, dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* Compte à rebours du drop */
  function initCountdown(el) {
    if (el.getAttribute('data-bound')) return;
    el.setAttribute('data-bound', '1');
    var end = new Date(el.getAttribute('data-rv-countdown')).getTime();
    if (isNaN(end)) return;
    var section = el.closest('[data-rv-drop]') || el;
    var units = { d: el.querySelector('[data-u=d]'), h: el.querySelector('[data-u=h]'), m: el.querySelector('[data-u=m]'), s: el.querySelector('[data-u=s]') };
    var iv = null;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s <= 0) {
        section.querySelectorAll('.rv-cd-before').forEach(function (x) { x.hidden = true; });
        section.querySelectorAll('.rv-cd-after').forEach(function (x) { x.hidden = false; });
        if (iv) clearInterval(iv);
        return;
      }
      var d = Math.floor(s / 86400); s %= 86400;
      var h = Math.floor(s / 3600); s %= 3600;
      var m = Math.floor(s / 60); s %= 60;
      if (units.d) units.d.textContent = d;
      if (units.h) units.h.textContent = pad(h);
      if (units.m) units.m.textContent = pad(m);
      if (units.s) units.s.textContent = pad(s);
    }
    tick();
    iv = setInterval(tick, 1000);
  }

  function revealAll(root) {
    root.querySelectorAll('.rv-reveal').forEach(function (el) { el.classList.add('is-in'); });
    root.querySelectorAll('[data-rv-count]').forEach(animateCount);
  }

  function init(root) {
    root = root || document;
    var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        if (en.target.hasAttribute('data-rv-count')) animateCount(en.target);
        else en.target.classList.add('is-in');
      });
    }, { threshold: 0.1 }) : null;

    root.querySelectorAll('[data-rv-count]').forEach(function (el) {
      if (io) { el.textContent = fmt(0, parseInt(el.getAttribute('data-decimals') || '0', 10)); io.observe(el); }
      else animateCount(el);
    });
    root.querySelectorAll('.rv-reveal').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });
    /* Filet de sécurité : rien ne reste invisible si l'observateur ne se déclenche pas */
    if (io) setTimeout(function () { revealAll(root); }, 2500);

    root.querySelectorAll('[data-rv-marquee-toggle]').forEach(function (btn) {
      if (btn.getAttribute('data-bound')) return;
      btn.setAttribute('data-bound', '1');
      btn.addEventListener('click', function () {
        var m = btn.closest('.rv-marquee');
        var paused = m.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.textContent = paused ? '▶' : '❚❚';
      });
    });

    root.querySelectorAll('[data-rv-countdown]').forEach(initCountdown);

    /* Historique des dons : du plus récent au plus ancien */
    root.querySelectorAll('[data-rv-sort-desc]').forEach(function (list) {
      var items = Array.prototype.slice.call(list.children);
      items.sort(function (a, b) { return (b.getAttribute('data-date') || '').localeCompare(a.getAttribute('data-date') || ''); });
      items.forEach(function (i) { list.appendChild(i); });
    });
  }

  /* Ajout rapide au panier (produit d'appoint) sans quitter le tiroir */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-rv-quick-add]')) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.routes) return; // repli : envoi classique
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    var sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(form.querySelector('[name=id]').value, 10), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.status) { window.location.href = window.routes.cart_url; return; }
      drawer.renderContents(state);
    }).catch(function () { window.location.href = window.routes.cart_url; });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
